<template>
    <div class="videos-wrap">
        <div class="panel-section-title">{{ $t('common.your_videos') }}</div>
        <v-btn block depressed class="upload-links-btn" @click="showUploadLinksDialog">
            {{ $t('common.upload_links') }} +
        </v-btn>

        <div v-if="hasLinks" class="video-card" @click="openVideo(currentLink)">
            <div class="video-thumb">
                <img v-if="!thumbError" :src="thumbUrl" alt="" @error="thumbError = true" />
                <div class="video-play-btn">
                    <v-icon size="40" color="white">mdi-play-circle</v-icon>
                </div>
            </div>
            <div class="video-info">
                <div class="video-title">{{ currentLink.name }}</div>
                <div class="video-author">{{ account.name }}</div>
            </div>
        </div>
        <div v-else class="no-links">{{ $t('common.no_links_yet') }}</div>

        <div v-if="links.length > 1" class="video-nav">
            <v-btn icon x-small class="video-nav-btn" @click="prev">
                <v-icon size="16">mdi-chevron-left</v-icon>
            </v-btn>
            <span class="video-counter">{{ index + 1 }} {{ $t('common.of') }} {{ links.length }}</span>
            <v-btn icon x-small class="video-nav-btn" @click="next">
                <v-icon size="16">mdi-chevron-right</v-icon>
            </v-btn>
        </div>

        <youtube-upload-links-dialog ref="links" />
        <agenda-video-dialog ref="video" />
    </div>
</template>

<script>
import YoutubeUploadLinksDialog from "@/components/coach/YoutubeUploadLinksDialog";
import AgendaVideoDialog from "@/components/coach/agenda/AgendaVideoDialog";

export default {
    name: "AgendaVideos",
    components: { YoutubeUploadLinksDialog, AgendaVideoDialog },
    data() {
        return {
            index: 0,
            thumbError: false,
        }
    },
    computed: {
        links(vm = this) {
            return vm.account?.links || []
        },
        hasLinks(vm = this) {
            return vm.links.length > 0
        },
        currentLink(vm = this) {
            return vm.links[vm.index] || null
        },
        thumbUrl(vm = this) {
            return vm.currentLink?.videoId ? `https://img.youtube.com/vi/${vm.currentLink.videoId}/mqdefault.jpg` : null
        },
    },
    methods: {
        showUploadLinksDialog() {
            this.$refs.links.show()
        },
        openVideo(link) {
            if (link?.videoId) this.$refs.video.show(link)
        },
        prev() {
            this.index = (this.index - 1 + this.links.length) % this.links.length
        },
        next() {
            this.index = (this.index + 1) % this.links.length
        },
    },
    watch: {
        currentLink() {
            this.thumbError = false
        },
        links(val) {
            if (this.index > val.length - 1) this.index = 0
        },
    },
}
</script>

<style scoped>
.videos-wrap {
    padding: 16px 20px 20px;
}

.panel-section-title {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
    margin-bottom: 10px;
}

.upload-links-btn {
    height: 38px !important;
    background: linear-gradient(135deg, rgba(204, 255, 51, 0.15), rgba(51, 153, 153, 0.15)) !important;
    color: var(--v-primary-base) !important;
    border: 1.5px solid rgba(204, 255, 51, 0.55) !important;
    border-radius: 8px !important;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: normal;
    margin-bottom: 12px;
    transition: opacity 0.15s, border-color 0.15s;
}

.upload-links-btn:hover {
    opacity: 0.9;
    border-color: rgba(204, 255, 51, 0.6) !important;
}

.theme--light .upload-links-btn {
    background: rgba(51, 153, 153, 0.1) !important;
    color: var(--v-accent-base) !important;
    border-color: rgba(51, 153, 153, 0.35) !important;
}

.theme--light .upload-links-btn:hover {
    background: rgba(51, 153, 153, 0.16) !important;
    border-color: rgba(51, 153, 153, 0.6) !important;
}

.video-card {
    background: var(--v-surface2-base);
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid var(--v-outline-base);
    cursor: pointer;
    transition: border-color 0.15s;
}

.video-card:hover {
    border-color: var(--v-outline2-base);
}

.video-thumb {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #000;
    position: relative;
    overflow: hidden;
}

.video-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.85;
}

.video-play-btn {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.video-play-btn >>> .v-icon {
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.6));
}

.video-info {
    padding: 10px 12px;
}

.video-title {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
    line-height: 1.4;
    margin-bottom: 2px;
}

.video-author {
    font-size: 11px;
    color: var(--v-txtSecondary-base);
}

.no-links {
    font-size: 13px;
    color: var(--v-txtMuted-base);
    padding: 8px 0;
}

.video-nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
}

.video-nav-btn {
    width: 26px !important;
    height: 26px !important;
    border-radius: 6px !important;
    background: linear-gradient(135deg, rgba(204, 255, 51, 0.15), rgba(51, 153, 153, 0.15)) !important;
    border: 1px solid rgba(204, 255, 51, 0.35) !important;
    transition: background 0.15s, border-color 0.15s;
}

.video-nav-btn >>> .v-icon {
    color: var(--v-txtSecondary-base);
}

.video-nav-btn:hover {
    border-color: rgba(204, 255, 51, 0.6) !important;
}

.theme--light .video-nav-btn >>> .v-icon {
    color: var(--v-accent-base);
}

.theme--light .video-nav-btn {
    background: rgba(51, 153, 153, 0.1) !important;
    border-color: rgba(51, 153, 153, 0.35) !important;
}

.theme--light .video-nav-btn:hover {
    background: rgba(51, 153, 153, 0.16) !important;
    border-color: rgba(51, 153, 153, 0.6) !important;
}

.video-counter {
    font-size: 11px;
    color: var(--v-txtMuted-base);
}
</style>
